import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import DataTable from 'react-data-table-component';
import { api } from '../api';

function Support() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState('');
  const [statusAction, setStatusAction] = useState(''); // 'PENDING' or 'RESOLVED'

  useEffect(() => {
    setLoading(true);
    api.getTickets(page, limit).then(res => {
      setTickets(res.tickets);
      setPage(res.page);
      setLimit(res.limit);
      setTotal(res.total);
      setLoading(false);
    });
  }, [page, limit]);

  function openTicket(ticket) {
    setSelectedTicket(ticket);
    setModalError('');
    try {
      const el = document.getElementById('ticketModal');
      if (el && window.bootstrap) (window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el)).show();
    } catch {}
  }

  async function handleStatusUpdate(status) {
    if (!selectedTicket) return;
    setModalLoading(true);
    setStatusAction(status);
    setModalError('');
    try {
      const updated = await api.updateTicket(selectedTicket.id, { status });
      if (updated) {
        setTickets(tickets => tickets.map(t => t.id === selectedTicket.id ? { ...t, status } : t));
        setSelectedTicket(st => st ? { ...st, status } : st);
      } else {
        setModalError('Failed to update status.');
      }
    } catch (err) {
      setModalError(err?.message || 'An error occurred while updating status.');
    } finally {
      setModalLoading(false);
      setStatusAction('');
    }
  }

  const columns = [
    { name: 'Ticket ID', selector: row => row.ticketId, sortable: true },
    { name: 'Subject', selector: row => row.title, sortable: true },
    { name: 'Requester', selector: row => row.user?.fullName || row.user?.email || '', sortable: true },
    { name: 'Status', selector: row => row.status, sortable: true, cell: row => (
      <span className={`ec-status ${row.status === 'PENDING' ? 'ec-pending' : row.status === 'RESOLVED' ? 'ec-active' : 'ec-inactive'}`}>{row.status}</span>
    ) },
    { name: 'Created', selector: row => new Date(row.createdAt).toLocaleString(), sortable: true },
    { name: 'Action', cell: row => (
      <button className="btn btn-outline-success" onClick={() => openTicket(row)}>View</button>
    ), ignoreRowClick: true, allowOverflow: true, button: true },
  ];

  return (
    <>
      <Helmet><title>Help & Support | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Support Tickets</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={e=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Support</p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="ec-vendor-list card card-default">
                <div className="card-body">
                  <DataTable
                    columns={columns}
                    data={tickets}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={total}
                    paginationPerPage={limit}
                    paginationDefaultPage={page}
                    onChangePage={setPage}
                    onChangeRowsPerPage={setLimit}
                    highlightOnHover
                    pointerOnHover
                    responsive
                    noDataComponent={<div className="text-center">No tickets found.</div>}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Ticket Modal */}
          <div className="modal fade" id="ticketModal" tabIndex="-1" aria-labelledby="ticketModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered"><div className="modal-content">
              <div className="modal-header px-4"><h5 className="modal-title" id="ticketModalLabel">Ticket</h5><button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div>
              <div className="modal-body px-4">
                {modalError && <div className="alert alert-danger py-2 mb-2">{modalError}</div>}
                {selectedTicket ? (
                  <div>
                    <div className="row mb-3">
                      <div className="col-md-6"><strong>ID:</strong> {selectedTicket.ticketId}</div>
                      <div className="col-md-6"><strong>Created:</strong> {new Date(selectedTicket.createdAt).toLocaleString()}</div>
                    </div>
                    <div className="mb-3"><strong>Subject:</strong> {selectedTicket.title}</div>
                    <div className="mb-3"><strong>Description:</strong> {selectedTicket.description}</div>
                    <div className="mb-3"><strong>Requester:</strong> {selectedTicket.user?.fullName || selectedTicket.user?.email || ''}</div>
                    <div className="mb-3"><strong>User Type:</strong> {selectedTicket.userType}</div>
                    <div className="mb-3"><strong>Status:</strong> {selectedTicket.status}</div>
                    <div className="mb-3"><strong>Note:</strong> {selectedTicket.note || '-'}</div>
                    <div className="d-flex gap-2">
                      <button className="btn btn-outline-success" disabled={modalLoading} onClick={() => handleStatusUpdate('PENDING')}>
                        {modalLoading && statusAction === 'PENDING' ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : null}
                        {modalLoading && statusAction === 'PENDING' ? 'Marking Pending...' : 'Mark Pending'}
                      </button>
                      <button className="btn btn-outline-primary" disabled={modalLoading} onClick={() => handleStatusUpdate('RESOLVED')}>
                        {modalLoading && statusAction === 'RESOLVED' ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : null}
                        {modalLoading && statusAction === 'RESOLVED' ? 'Marking Resolved...' : 'Mark Resolved'}
                      </button>
                    </div>
                  </div>
                ) : <p>No ticket selected.</p>}
              </div>
            </div></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Support;
